import React, { ReactNode } from "react";
import { Form } from "@/components/ui/form";
import { UseFormReturn, FieldValues } from "react-hook-form";

interface FormErrorDisplayProps {
	error?: unknown;
}

const FormErrorDisplay: React.FC<FormErrorDisplayProps> = ({ error }) => {
	const apiError = error as unknown as ApiError;

	if (!error) {
		return null;
	}

	const isInputValidationErrors =
		!!apiError?.validationErrors && Object.keys(apiError?.validationErrors || {}).length > 0;

	if (isInputValidationErrors) {
		return null;
	}

	const message = apiError.message;

	return (
		<div className="mb-4 p-2 text-sm text-red-700 bg-red-100 border border-red-400 rounded-md shadow-sm">
			{message}
		</div>
	);
};

interface FormWrapperProps<T extends FieldValues> extends FormErrorDisplayProps {
	form: UseFormReturn<T>;
	onSubmit: (data: T) => void;
	children: ReactNode;
	className?: string;
}

export function FormWrapper<T extends FieldValues>({
	form,
	onSubmit,
	children,
	className = "w-full space-y-4",
	error,
}: FormWrapperProps<T>) {
	const { handleSubmit } = form;

	return (
		<Form {...form}>
			<form onSubmit={handleSubmit(onSubmit)} className={className}>
				<FormErrorDisplay error={error} />
				<div className="flex flex-col gap-6">{children}</div>
			</form>
		</Form>
	);
}
